/**
 * @generated SignedSource<<e21c4dd906ab1e7e0e623fa6bef2db44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useLocationsRelayByIdQuery$variables = {
  id: string;
};
export type useLocationsRelayByIdQuery$data = {
  readonly getLocation: {
    readonly availableHardwareCount: number;
    readonly avgRentalsEndedPerUser: number | null | undefined;
    readonly avgRentalsStartedPerUser: number | null | undefined;
    readonly bannerId: string | null | undefined;
    readonly capacity: number | null | undefined;
    readonly configuration: string | null | undefined;
    readonly icon: {
      readonly approvedOn: any | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly iconId: string | null | undefined;
    readonly id: string;
    readonly lat: number | null | undefined;
    readonly lng: number | null | undefined;
    readonly maxReservations: number | null | undefined;
    readonly module: string | null | undefined;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly polygonCoordinates: ReadonlyArray<ReadonlyArray<number>> | null | undefined;
    readonly preventEndingRentals: boolean | null | undefined;
    readonly preventStartingRentals: boolean | null | undefined;
    readonly private: boolean | null | undefined;
    readonly radius: number | null | undefined;
    readonly rates: ReadonlyArray<{
      readonly archivedOn: any | null | undefined;
      readonly baseRate: number | null | undefined;
      readonly baseRateIncludedTime: number | null | undefined;
      readonly creditCardHold: number | null | undefined;
      readonly freeTime: number | null | undefined;
      readonly hidden: boolean | null | undefined;
      readonly id: string;
      readonly maxPeriods: number | null | undefined;
      readonly membershipRequired: boolean;
      readonly minimumWalletDeposit: number | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly periodDuration: number | null | undefined;
      readonly pricePerPeriod: number | null | undefined;
    }> | null | undefined;
    readonly rentalsEndedCount: number | null | undefined;
    readonly rentalsStartedCount: number | null | undefined;
    readonly reservations: boolean | null | undefined;
    readonly slowZoneSpeed: number | null | undefined;
    readonly state: number | null | undefined;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly timezone: string;
    } | null | undefined;
    readonly totalHardwareCount: number;
    readonly totalRentableHardwareCount: number;
    readonly zoneType: string | null | undefined;
  } | null | undefined;
};
export type useLocationsRelayByIdQuery = {
  response: useLocationsRelayByIdQuery$data;
  variables: useLocationsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Location",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "configuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lng",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "polygonCoordinates",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "capacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zoneType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slowZoneSpeed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxReservations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preventEndingRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preventStartingRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "private",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "module",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bannerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRentableHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentalsStartedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentalsEndedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgRentalsStartedPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgRentalsEndedPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rate",
        "kind": "LinkedField",
        "name": "rates",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baseRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baseRateIncludedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pricePerPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxPeriods",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creditCardHold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumWalletDeposit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLocationsRelayByIdQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLocationsRelayByIdQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4d861f283b81fd07f1b7cb9af16bcaeb",
    "id": null,
    "metadata": {},
    "name": "useLocationsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useLocationsRelayByIdQuery(\n  $id: ID!\n) {\n  getLocation(id: $id) {\n    id\n    oldId\n    name\n    state\n    configuration\n    lat\n    lng\n    polygonCoordinates\n    capacity\n    radius\n    zoneType\n    slowZoneSpeed\n    reservations\n    maxReservations\n    preventEndingRentals\n    preventStartingRentals\n    private\n    module\n    bannerId\n    iconId\n    availableHardwareCount\n    totalHardwareCount\n    totalRentableHardwareCount\n    rentalsStartedCount\n    rentalsEndedCount\n    avgRentalsStartedPerUser\n    avgRentalsEndedPerUser\n    system {\n      id\n      oldId\n      name\n      timezone\n    }\n    icon {\n      id\n      name\n      type\n      approvedOn\n    }\n    rates {\n      id\n      oldId\n      name\n      baseRate\n      baseRateIncludedTime\n      freeTime\n      pricePerPeriod\n      periodDuration\n      maxPeriods\n      creditCardHold\n      minimumWalletDeposit\n      membershipRequired\n      hidden\n      archivedOn\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d27da180bd70fa7cafd573c7e6829f2e";

export default node;
